import COLORS from './beam2';

// Note: This will overwrite duplicates in the order they were created
const COLORS_FLAT = {
  ...COLORS.neutral,
  ...COLORS.blue,
  ...COLORS.green,
  ...COLORS.yellow,
  ...COLORS.red,
  ...COLORS.violet,
  ...COLORS.teal,
  ...COLORS.pink,
  ...COLORS.orange,
};

export type T_COLORS_FLAT = typeof COLORS_FLAT;
export type T_COLOR_SHADES = keyof T_COLORS_FLAT;
export default COLORS_FLAT;
